import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import askanalystlogo from '../../assets/media/images/askanalyst2.svg';
import alphaanalystlogo from '../../assets/media/images/alphaanalyst.svg';
import UserImg from '../../assets/media/images/profile_user.jpg';
import 'font-awesome/css/font-awesome.min.css';
import { Cookies, useCookies } from 'react-cookie';
import { Redirect, useHistory } from 'react-router-dom';
import { Link, useLocation, Navigate } from 'react-router-dom';
import { IconSun, IconMoon } from '@tabler/icons-react';
import axios from 'axios';
// import IdleTimer from '../../IdleTimerContainer';
// import SessionExpire from '../../layout/login/sessionExpire';
// import WhatsappImage from "../../assets/media/images/WhatsApp.svg";
import { Tooltip } from '@mantine/core';
import { comingsoon, modal_excel_icon } from '../../api/baseUrl';

const Navbar = (props) => {
  const location = useLocation();
  const history = useHistory();

  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('theme') === 'dark';
  });

  console.log(window.location.hostname);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.classList.remove('dark-mode');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  const [userAction, setUserAction] = useState(false);
  const [sessionModal, setSessionModal] = useState(false);
  const [sessionMessage, setSessionMessage] = useState('');

  const userInfo = JSON.parse(localStorage.getItem('userActive'));

  // const userInitial = userInfo.name.split('')[0];

  const [cookies, setCookies, removeCookies] = useCookies([
    'accessToken',
    'user',
  ]);
  const accessToken = cookies.accessToken;
  axios.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${cookies?.accessToken}`;

  let logo;
  let financialTab = true;
  if (window.location.host === 'analyst.alphacapital.com.pk') {
    logo = alphaanalystlogo;
    financialTab = false;
  } else if (window.location.host === 'askanalyst.akseerresearch.com') {
    logo = askanalystlogo;
    financialTab = true;
  } else {
    logo = askanalystlogo;
    financialTab = true;
  }

  const handleUserAction = () => {
    setUserAction(!userAction);
  };

  const handleSession = () => {
    setSessionModal(true);
  };

  const closeModal = () => {
    setSessionModal(false);
    sessionTimeout();
  };

  // start toggle js
  const [toggleMenu, setToggleMenu] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const toggleNav = () => {
    setToggleMenu(!toggleMenu);
  };

  useEffect(() => {
    const changeWidth = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', changeWidth);
  }, []);
  // end toggle js

  function sessionTimeout() {
    setSessionModal(false);
    removeCookies('accessToken');
    removeCookies('user');
    removeCookies('userInformation');
    removeCookies('company');
    localStorage.removeItem('sessionTime');
    history.replace('/');
  }

  const handleLogout = () => {
    removeCookies('user');
    removeCookies('userInformation');
    removeCookies('company');
    removeCookies('accessToken', { path: '/' });
  };

  const handleReset = () => {
    var accessTokenObj = JSON.parse(localStorage.getItem('userActive'));
    history.push(`/reset_password?token=${accessTokenObj.token}`);
  };

  const showMyCookies = () => {
    console.log('showing coookies from header', cookies);
  };

  var parameter = location.pathname.split('/');
  return (
    <>
      <div className="header feature-header">
        <nav className="navbar navbar-expand-lg navbar-light site-hide-tab">
          <Container className="container_box">
            <Row className="justify-content-between w-100 m-0 header-logo header-sizing align-items-center">
              {/* <Col md={2} xs={6} className="p-0"> */}
              <div className="navbar-brand">
                <a href="/">
                  <img src={logo} alt="logo" className="imglogo" />
                </a>
              </div>
              {/* </Col> */}
              <div
                className="collapse navbar-collapse nav-head-respons"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav mr-auto header-navbar-nav nav-header-col responsive-header">
                  <li className="nav-item header-items">
                    <Link
                      className={
                        'nav-link ' + (location.pathname == '/' ? 'active' : '')
                      }
                      to={{ pathname: `/` }}
                    >
                      <button
                        type="button"
                        id="controlled-tab-example-tab-technical"
                        role="tab"
                        data-rr-ui-event-key="technical"
                        aria-controls="controlled-tab-example-tabpane-technical"
                        tabIndex="-1"
                      >
                        Market
                      </button>
                    </Link>
                  </li>
                  <li className="nav-item header-items">
                    <Link
                      className={
                        'nav-link ' +
                        (parameter[1] == 'company' ? 'active' : '')
                      }
                      to={{ pathname: `/company/overview` }}
                    >
                      <button
                        type="button"
                        id="controlled-tab-example-tab-technical"
                        role="tab"
                        data-rr-ui-event-key="technical"
                        aria-controls="controlled-tab-example-tabpane-technical"
                        tabIndex="-1"
                      >
                        Companies
                      </button>
                    </Link>
                  </li>
                  <li className="nav-item header-items ">
                    <Link
                      className={
                        'nav-link ' +
                        (location.pathname == '/databank' ? 'active' : '')
                      }
                      to={{ pathname: `/databank` }}
                    >
                      <button
                        type="button"
                        id="controlled-tab-example-tab-technical"
                        role="tab"
                        data-rr-ui-event-key="technical"
                        aria-controls="controlled-tab-example-tabpane-technical"
                        tabIndex="-1"
                      >
                        Data Bank
                      </button>
                    </Link>
                  </li>
                  <li className="nav-item header-items ">
                    <Link
                      className={
                        'nav-link ' + (parameter[1] == 'sector' ? 'active' : '')
                      }
                      to={{ pathname: `/sector/chemical` }}
                    >
                      <button
                        type="button"
                        id="controlled-tab-example-tab-technical"
                        role="tab"
                        data-rr-ui-event-key="technical"
                        aria-controls="controlled-tab-example-tabpane-technical"
                        tabIndex="-1"
                      >
                        Sector Fundamentals
                      </button>
                    </Link>
                  </li>
                  <li className="nav-item header-items ">
                    <Link
                      className={
                        'nav-link ' +
                        (parameter[1] == 'economy' ? 'active' : '')
                      }
                      to={{ pathname: `/economy/currency` }}
                    >
                      <button
                        type="button"
                        id="controlled-tab-example-tab-technical"
                        role="tab"
                        data-rr-ui-event-key="technical"
                        aria-controls="controlled-tab-example-tabpane-technical"
                        tabIndex="-1"
                      >
                        Economy
                      </button>
                    </Link>
                  </li>
                  {window.location.hostname === 'demo.askanalyst.com.pk' ||
                  window.location.hostname === 'localhost' ? (
                    <li className="nav-item header-items ">
                      <Link
                        className={
                          'nav-link ' +
                          (parameter[1] == 'publisher' ? 'active' : '')
                        }
                        to={{ pathname: `/publisher/investment` }}
                      >
                        <button
                          type="button"
                          id="controlled-tab-example-tab-technical"
                          role="tab"
                          data-rr-ui-event-key="technical"
                          aria-controls="controlled-tab-example-tabpane-technical"
                          tabIndex="-1"
                        >
                          Publisher
                        </button>
                      </Link>
                    </li>
                  ) : (
                    ''
                  )}
                  <li className="nav-item header-items ">
                    <Link
                      className={
                        'nav-link ' + (parameter[1] == 'media' ? 'active' : '')
                      }
                      to={{ pathname: `/media/analystbriefing` }}
                    >
                      <button
                        type="button"
                        id="controlled-tab-example-tab-technical"
                        role="tab"
                        data-rr-ui-event-key="technical"
                        aria-controls="controlled-tab-example-tabpane-technical"
                        tabIndex="-1"
                      >
                        Media
                      </button>
                    </Link>
                  </li>

                  <li className="nav-item header-items ">
                    <Link
                      className={
                        'nav-link ' +
                        (parameter[1] == 'features' ? 'active' : '')
                      }
                      to={{ pathname: `/features` }}
                    >
                      <button
                        type="button"
                        id="controlled-tab-example-tab-technical"
                        role="tab"
                        data-rr-ui-event-key="technical"
                        aria-controls="controlled-tab-example-tabpane-technical"
                        tabIndex="-1"
                      >
                        Features
                      </button>
                    </Link>
                  </li>

                  <li className="nav-item header-items ">
                    <Link
                      className={
                        'nav-link ' +
                        (parameter[1] == 'calculator' ? 'active' : '')
                      }
                      to={{ pathname: `/calculator/salarytax` }}
                    >
                      <button
                        type="button"
                        id="controlled-tab-example-tab-technical"
                        role="tab"
                        data-rr-ui-event-key="technical"
                        aria-controls="controlled-tab-example-tabpane-technical"
                        tabIndex="-1"
                      >
                        Calculator
                      </button>
                    </Link>
                  </li>

                  {/* <li className="nav-item header-items">
                    <a
                      className={`nav-link ${
                        parameter[1] ===
                        'https://www.aof.com.pk/?NDIxMjQyNDg2Nzc0OTQ4NzMyNDQ4NDg3MTc2ODUyMjQ4NDc0ODQ5NA=='
                          ? 'active'
                          : ''
                      }`}
                      href="https://www.aof.com.pk/?NDIxMjQyNDg2Nzc0OTQ4NzMyNDQ4NDg3MTc2ODUyMjQ4NDc0ODQ5NA=="
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        type="button"
                        id="controlled-tab-example-tab-technical"
                        role="tab"
                        data-rr-ui-event-key="technical"
                        aria-controls="controlled-tab-example-tabpane-technical"
                        tabIndex="-1"
                      >
                        Open an Account
                      </button>
                    </a>
                  </li> */}

                  <li className="nav-item header-items ">
                    <Link
                      className={
                        'nav-link ' +
                        (parameter[1] == 'researchreport' ? 'active' : '')
                      }
                      to={{ pathname: `/researchreport/home` }}
                    >
                      <button
                        type="button"
                        id="controlled-tab-example-tab-technical"
                        role="tab"
                        data-rr-ui-event-key="technical"
                        aria-controls="controlled-tab-example-tabpane-technical"
                        tabIndex="-1"
                      >
                        Research Report
                      </button>
                    </Link>
                  </li>
                </ul>
              </div>
            </Row>
          </Container>
          <div className="site-hide">
            <span>
              <Link
                className={+(parameter[1] == 'sitemap' ? 'active' : '')}
                to={{ pathname: `/sitemap` }}
              >
                aa
              </Link>
            </span>
          </div>
        </nav>
      </div>

      {/* <SessionExpire
        sessionModal={sessionModal}
        closeModal={closeModal}
        sessionMessage={sessionMessage}
      /> */}
    </>
  );
};

export default Navbar;
